module.exports = __webpack_public_path__ + "static/media/a4.64f552c1.jpg";